<template v-if="meshColors.length > 0">
  <button-card-config
    v-for="color in meshColors"
    :key="color.name"
    :title="getSafeTitle(color.name)"
    @click="emitMeshColorSelected(color)"
    class="card-custom"
    :class="{ active: selectedColor && selectedColor.name === color.name }"
  >
    <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
  </button-card-config>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { RGB2 } from '@/types/api/Utility/RGB2';
import ButtonCardConfig from '../layout/ButtonCardConfig.vue';
import { safeT } from '@/utils/text';

@Component({
  components: {
    ButtonCardConfig,
  },
  emits: ['meshColorSelected'],
})
@Component
export default class MeshColorSelector extends Vue {
  // Props
  @Prop({ default: null }) selectedProductName!: string | null;
  @Prop({ required: true }) selectedColor!: RGB2;
  @Prop({ required: true }) selectedEngraving!: number;
  @Prop({ required: true }) meshEmbossingColors!: RGB2[];
  @Prop({ required: true }) meshColors!: RGB2[];
  @Prop({ required: true }) meshTextureColors!: RGB2[];


  // Emit methods
  emitMeshColorSelected(color: RGB2) {
    this.$emit('meshColorSelected', color);
    localStorage.setItem('orderColor', color.name);
  }

  getSafeTitle(colorName: string) {
    return safeT({ t: this.$t, category: 'colors', keyName: colorName });
  }
}
</script>

<style lang="scss">
.scroll-wrapper::-webkit-scrollbar {
  height: 8px;
}
.scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
.scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.card-custom {
  width: 130px !important;
  height: 130px !important;
  cursor: pointer;
}

.card {
  border-color: #1d1e19 !important;
  border-width: 2px !important;
  transition: all 0.1s ease-in-out;
}

.card.active {
  border-color: #ac0c0c !important;
  border-width: 4px !important;
}

.card:hover {
  transform: scale(1.03);
}

.img {
  height: 9rem;
  width: 9rem;
}

.rounded-circle {
  height: 48px !important;
  width: 48px !important;
}
</style>
